module.exports = __webpack_public_path__ + "img/icon-menu-mobile.53571853.svg";